var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pd-t-50 pd-b-30"},[_c('div',{staticClass:"text-center",staticStyle:{"color":"white"}},[_vm._v(" Засгийн газрын Хэрэг эрхлэх газар, Дэлхийн банкны санхүүжилтээр "),_c('br'),_vm._v("\"Ухаалаг засаг\" төслийн хүрээнд энэхүү Цахим сургалтын платформыг нэвтрүүлэв. ")])])
}]

export { render, staticRenderFns }